import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getTopicList, getTopicInfo } from "@/api/managementCenter/specialManage";
import queryTypeModal from "@/components/common/queryTypeModal.vue";
import IframeView from "@/components/public/IframeView.vue";
import { bpmnStartProcess } from "@/api/bpmnApi/bpmn";
export default {
  name: "topicdl",
  components: {
    queryTypeModal: queryTypeModal,
    IframeView: IframeView
  },
  props: ["moduleData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      activeValue: "",
      titleData: [],
      itemData: [],
      servicesInput: "",
      activeIndex: 0,
      activeName: "",
      value: 5,
      middlePage: JSON.parse(window.sessionStorage.getItem("setConfig")).middlePage,
      dataModal: {
        show: false,
        data: {}
      }
    };
  },
  created: function created() {
    // this.activeValue = this.moduleData.cardModules[0].data[0].topicId
    // this.activeName = this.moduleData.cardModules[0].data[0].topicName
    this.getTitleData();
  },
  computed: {},
  methods: {
    getTitleData: function getTitleData() {
      var _this = this;

      var param = {
        current: 1,
        size: 100,
        name: this.servicesInput || ""
      };
      getTopicList(param).then(function (res) {
        _this.titleData = res.data.data.records;
        _this.activeValue = _this.titleData[0].id;
        _this.activeName = _this.titleData[0].name;

        _this.handleClick();
      });
    },
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    handleClick: function handleClick() {
      var _this2 = this;

      getTopicInfo(this.activeValue).then(function (res) {
        _this2.itemData = res.data.data.selectedServes;
      });
    },
    goServe: function goServe(row) {
      if (row.serveType == "0" && row.queryType == "2") {
        this.dataModal.show = true;
        this.dataModal.data = row;
      }

      if (row.serveType == "0" && row.queryType == "1") {
        this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId);
      }

      if (row.serveType == "1" && row.queryType == "0") {
        if (!this.middlePage) {
          this.HandleApply(row);
        } else {
          var routeData = this.$router.resolve({
            path: "/ServeCenterDetail",
            query: {
              id: row.serveId
            }
          });
          window.open(routeData.href);
        }
      }
    },
    onDialogClose: function onDialogClose() {
      this.dataModal.show = false;
    },
    HandleApply: function HandleApply(item) {
      var _this3 = this;

      var processDefId = item.processDefId;
      bpmnStartProcess({
        processDefId: processDefId
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          window.sessionStorage.setItem("processInstId", data.data.processInstId);

          _this3.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
        } else {
          _this3.$message.warning(data.msg || "流程系统业务忙，请刷新或者重新操作");
        }
      }).catch(function (err) {
        _this3.$message.error("服务异常");
      });
    }
  },
  watch: {},
  filters: {}
};